// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5v0Qh","column":"styles_column__RyUz7"};